if (!customElements.get('promo-countdown')) {
  customElements.define(
    'promo-countdown',
    class PromoCountdown extends HTMLElement {
      connectedCallback() {
        this.deadline = new Date(this.dataset.deadline).getTime();
        if (!this.deadline || Number.isNaN(this.deadline)) return;

        this.overlay = this.querySelector('.promo__overlay');
        this.dialog = this.querySelector('.promo__dialog');
        this.mini = this.querySelector('.promo__mini');
        this.closeButton = this.querySelector('.promo__close');
        this.codeButton = this.querySelector('.promo__code');
        this.units = {
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
          full: this.querySelector('[data-unit="full"]'),
        };

        // Tope de horas: un contador de 24 h no muestra 25 h aunque falten mas.
        this.maxMs = (parseInt(this.dataset.maxHours, 10) || 24) * 3600000;

        if (this.remaining() <= 0) return;

        this.cta = this.querySelector('.promo__cta');
        this.miniText = this.querySelector('.promo__mini-text');
        this.applied = this.dataset.applied === 'true';

        this.onKeydown = this.onKeydown.bind(this);
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
        this.mini?.addEventListener('click', () => this.open());
        this.codeButton?.addEventListener('click', (event) => this.applyDiscount(event));
        this.cta?.addEventListener('click', (event) => this.applyDiscount(event));

        this.paintMiniText();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);

        // En el editor del tema siempre se abre, para poder verla y ajustarla.
        if (window.Shopify?.designMode) {
          this.openLater();
        } else if (this.applied || this.dismissed) {
          this.showMini();
        } else {
          this.openLater();
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('keydown', this.onKeydown);
      }

      get dismissed() {
        try {
          return localStorage.getItem(this.dataset.storageKey) === 'cerrado';
        } catch (e) {
          return false;
        }
      }

      set dismissed(value) {
        try {
          if (value) localStorage.setItem(this.dataset.storageKey, 'cerrado');
        } catch (e) {
          /* modo privado: solo se pierde el recuerdo del cierre */
        }
      }

      remaining() {
        return this.deadline - Date.now();
      }

      openLater() {
        const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        this.openTimer = setTimeout(() => this.open(), delay);
      }

      open() {
        clearTimeout(this.openTimer);
        this.classList.remove('is-mini');
        this.classList.add('is-open');
        this.dialog.focus();
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        clearTimeout(this.openTimer);
        clearTimeout(this.successTimer);
        this.classList.remove('is-open', 'is-success');
        this.dismissed = true;
        document.removeEventListener('keydown', this.onKeydown);
        this.showMini();
      }

      showMini() {
        this.classList.add('is-mini');
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }

      // El enlace del boton aplica el cupon igual si el JS no corre; con JS se
      // aplica sin salir de la pagina y la ventana se cierra sola.
      async applyDiscount(event) {
        event.preventDefault();

        const code = this.codeButton?.dataset.code;
        if (code) {
          try {
            // cart/update.js responde en la mitad de tiempo que /discount/CODE,
            // que ademas arrastra el HTML completo de la pagina de destino.
            const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: code }),
            });
            if (!response.ok) throw new Error(response.status);
          } catch (e) {
            // Sin conexion o respuesta rara: el enlace normal queda como salida.
            window.location.href = this.cta.getAttribute('href');
            return;
          }
        }

        this.applied = true;
        this.paintMiniText();
        this.refreshCart();

        // El aviso de exito se queda un momento antes de cerrar la ventana.
        this.classList.add('is-success');
        this.successTimer = setTimeout(() => this.close(), 2400);
      }

      paintMiniText() {
        if (!this.miniText) return;

        const text = this.applied ? this.miniText.dataset.appliedText : this.miniText.dataset.text;
        if (text) this.miniText.textContent = text;
      }

      // Repinta el cajon del carrito para que muestre el descuento recien puesto.
      async refreshCart() {
        try {
          const response = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
          const sections = await response.json();
          const parser = new DOMParser();

          const drawer = document.querySelector('#CartDrawer');
          if (drawer && sections['cart-drawer']) {
            drawer.innerHTML = parser
              .parseFromString(sections['cart-drawer'], 'text/html')
              .querySelector('#CartDrawer').innerHTML;
          }

          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            bubble.innerHTML = parser
              .parseFromString(sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
        } catch (e) {
          /* el carrito se pondra al dia solo en el proximo cambio */
        }
      }

      tick() {
        const left = this.remaining();

        if (left <= 0) {
          clearInterval(this.timer);
          this.remove();
          return;
        }

        const capped = Math.min(left, this.maxMs);
        const total = Math.floor(capped / 1000);
        const hours = Math.floor(total / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        this.write(this.units.hours, hours);
        this.write(this.units.minutes, minutes);
        this.write(this.units.seconds, seconds);

        if (this.units.full) {
          this.units.full.textContent = [hours, minutes, seconds].map(this.pad).join(':');
        }
      }

      write(element, value) {
        if (element) element.textContent = this.pad(value);
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }
    }
  );
}
